<template>
  <div class="table__sort-btns">
    <button class="table__sort-btn" @click="$emit('asc')">
      <svg
        width="16"
        height="8"
        viewBox="0 0 16 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 6H5L8 1L11 6Z" />
      </svg>
    </button>
    <button class="table__sort-btn" @click="$emit('desc')">
      <svg
        width="16"
        height="8"
        viewBox="0 0 16 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 2L11 2L8 7L5 2Z" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TableSortBtn'
};
</script>

<style scoped></style>
